import { formatCurrency as formatCurrencyShared, formatDate as formatDateShared } from '../../../utils/formatUtils';

export function formatAfipDate(dateStr) {
  if (!dateStr || dateStr.length !== 8) return '';
  const yyyy = dateStr.slice(0, 4);
  const mm = dateStr.slice(4, 6);
  const dd = dateStr.slice(6, 8);
  return `${dd}/${mm}/${yyyy}`;
}

export const formatCurrency = (value) => formatCurrencyShared(value, { fallback: '' });

export const formatAmount = (amount) => formatCurrencyShared(amount, { fallback: '' });

export const formatDate = (dateStr) => formatDateShared(dateStr, { fallback: '' });
